import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../../../buttons/versionHistoryBtn";

const PharmacyBulkErrorModal = ({
  show,
  ShowClose,
  pharmacyBluckStatusData,
}) => {
  return (
    <Modal
      centered
      show={show}
      onHide={ShowClose}
      dialogClassName="field-force-table-container col-10 px-5 mx-auto"
      size=""
    >
      <ModalHeader className="d-flex justify-content-between align-items-center">
        <div>
          <span className="fn_Nunito fw_600 fs_18">
            Pharmacy data upload report
          </span>
        </div>
        <div className=" d-flex justify-content-between m-1 mb-2">
          <AdminButton
            background="#E7E5FF"
            width="100px"
            type="button"
            onClick={() => ShowClose()}
          >
            CLOSE
          </AdminButton>
        </div>
      </ModalHeader>
      <ModalBody className="text-nowrap">
        <div className="mx-3">
          <span>
            Pharmacy created successfully
            <span className="color_2ad3e7 ms-1">
              {pharmacyBluckStatusData?.created?.length}
            </span>
          </span>
        </div>
        {/* CREATED */}
        {pharmacyBluckStatusData?.created?.length > 0 && (
          <div className="my-2 mt-4">
            <div
              style={{ background: "#24d626", borderRadius: "5px" }}
              className="p-2 text-white"
            >
              Pharmacy : Created
              <span className="mx-1">
                ( {pharmacyBluckStatusData?.created?.length} )
              </span>
            </div>
            <div className="modal-table-container my-2">
              <div
                className="table-container text-nowrap"
                style={{ minHeight: "13.5rem", maxHeight: "13.5rem" }}
              >
                <table className="main-table">
                  <thead>
                    <tr className="table-rows color_747f9e">
                      <th className="table-heads " width={"3%"}>
                        SL No.
                      </th>
                      <th className="table-heads " width={"10%"}>
                        Pharmacy Name
                      </th>
                      <th className="table-heads " width={"14%"}>
                        Email Address
                      </th>
                      <th className="table-heads " width={"8%"}>
                        Mobile
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pharmacyBluckStatusData?.created?.map((item, index) => (
                      <tr className="table-rows1 ">
                        <td className="table-each-row-data">{index + 1}</td>
                        <td className="table-each-row-data">
                          {item?.pharmacy_name}
                        </td>
                        <td className="table-each-row-data">{item?.email}</td>
                        <td className="table-each-row-data">{item?.mobile}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* EMAIL */}
        {pharmacyBluckStatusData?.emailAlreadyExists?.length > 0 && (
          <div className="my-2 mt-4">
            <div
              style={{ background: "#FF6F5B", borderRadius: "5px" }}
              className="p-2 text-white"
            >
              Pharmacy : E-mail already exists
              <span className="mx-1">
                ( {pharmacyBluckStatusData?.emailAlreadyExists?.length} )
              </span>
            </div>
            <div className="modal-table-container my-2">
              <div
                className="table-container text-nowrap"
                style={{ minHeight: "13.5rem", maxHeight: "13.5rem" }}
              >
                <table className="main-table">
                  <thead>
                    <tr className="table-rows color_747f9e">
                      <th className="table-heads " width={"3%"}>
                        SL No.
                      </th>
                      <th className="table-heads " width={"10%"}>
                        Pharmacy Name
                      </th>
                      <th className="table-heads " width={"14%"}>
                        Email Address
                      </th>
                      <th className="table-heads " width={"8%"}>
                        Mobile
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pharmacyBluckStatusData?.emailAlreadyExists?.map(
                      (item, index) => (
                        <tr className="table-rows1 ">
                          <td className="table-each-row-data">{index + 1}</td>
                          <td className="table-each-row-data">
                            {item?.pharmacy_name}
                          </td>
                          <td className="table-each-row-data">{item?.email}</td>
                          <td className="table-each-row-data">
                            {" "}
                            {item?.mobile}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* MOBILE */}
        {pharmacyBluckStatusData?.mobileAlreadyExists?.length > 0 && (
          <div className="my-2 mt-4">
            <div
              style={{ background: "#FF6F5B", borderRadius: "5px" }}
              className="p-2 text-white"
            >
              Pharmacy : Mobile already exists
              <span className="mx-1">
                ( {pharmacyBluckStatusData?.mobileAlreadyExists?.length} )
              </span>
            </div>
            <div className="modal-table-container my-2">
              <div
                className="table-container text-nowrap"
                style={{ minHeight: "13.5rem", maxHeight: "13.5rem" }}
              >
                <table className="main-table">
                  <thead>
                    <tr className="table-rows color_747f9e">
                      <th className="table-heads " width={"3%"}>
                        SL No.
                      </th>
                      <th className="table-heads " width={"10%"}>
                        Pharmacy Name
                      </th>
                      <th className="table-heads " width={"14%"}>
                        Email Address
                      </th>
                      <th className="table-heads " width={"8%"}>
                        Mobile
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pharmacyBluckStatusData?.mobileAlreadyExists?.map(
                      (item, index) => (
                        <tr className="table-rows1 ">
                          <td className="table-each-row-data">{index + 1}</td>
                          <td className="table-each-row-data">
                            {item?.pharmacy_name}
                          </td>
                          <td className="table-each-row-data">{item?.email}</td>
                          <td className="table-each-row-data">
                            {item?.mobile}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default PharmacyBulkErrorModal;
